module.exports = __webpack_public_path__ + "static/media/cara_talk.10dea110.png";